import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SearchMediaComponent} from './search-media/search-media.component';
import {MediaDetailComponent} from './media-detail/media-detail.component';

const routes: Routes = [
	{
		path: 'search/:type',
		component: SearchMediaComponent,
	},
	{
		path: 'search',
		redirectTo: 'search/images'
	},
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'search/images'
	},
	{
		path: 'detail/:type/:collection/:id',
		component: MediaDetailComponent,
	},
	{
		path: 'category/:searchText',
		component: SearchMediaComponent,
	},
];

@NgModule( {
	imports: [ RouterModule.forChild( routes ) ],
	exports: [ RouterModule ]
} )



export class ProductsRoutingModule { };
